import React, { useContext, useEffect, useState } from "react";
import "./bookingDetails.scss";
import BoxInfoCard from "../../commonComponents/Card/boxInfoCard";
import { Button, notification, Select, Tooltip } from "antd";
import DefaultButton from "../../commonComponents/buttons/button";
import useStudios, { useListingStudios } from "../../hooks/useStudios";
import { useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import DynamicModal from "../../commonComponents/DynamicModal/DynamicModal";
import CourierList from "../CourierList/CourierList";
import { useBookOrder, useReturnShipment } from "../../hooks/useOrders";
import { fetchOrderDetails, useCreateShipment } from "../../hooks/useOrders";
import BookingHeader from "./BookingHeader";
import { Spin } from "antd";

import { Card } from "antd";
import BoxInfoModal from "../orders/boxInfoModal";
import { v4 as uuidv4 } from "uuid";
import { useGetDefaults } from "../../hooks/useDefault";
import { useCompanies } from "../../hooks/useCompanies";
import useLogout from "../../hooks/useLogout";
import { OrderContext } from "../../context/orderContext";
import { CloseSquareOutlined } from "@ant-design/icons";

const { Option } = Select;
const Success = "success";
const Pending = "pending";
const Failed = "failed";

const BookingDetails = (props) => {
  const [assignedStudioId, setAssignedStudioId] = useState("");
  const [api, contextHolder] = notification.useNotification();
  const [boxId, setBoxId] = useState("");
  const [courierDetails, setCourierDetails] = useState({});
  const [courierFlag, setCourierFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const [boxInfoCopy, setBoxInfoCopy] = useState([]);
  const [boxInfoFlag, setBoxInfoFlag] = useState(false);
  const [isParentBox, setIsParentBox] = useState(false);
  const [isReturnBySelf, setIsReturnBySelf] = useState(false);
  const [isReturnByFlx, setIsReturnByFlx] = useState(false);
  const [selectedBoxForReturn, setSelectedBoxForReturn] = useState(null);
  const [isReturningBox, setIsReturningBox] = useState(false);
  let orderId = location?.state?.orderId;
  const { logout } = useLogout();

  const { address } = useContext(OrderContext);
  const [companyAddress, setCompanyAddress] = address;

  // const transformation = (data) => {
  // 	return data.map((item) => {
  // 		return {
  // 			name: `${item.name}`,
  // 			key: item._id,
  // 		};
  // 	});
  // };

  const onSuccess = (values) => {
    // console.log(values);
  };

  const onError = (err) => {
    err.response.data.message &&
      api.error({
        message: "Great!",
        description: err.response.data.message,
        placement: "topRight",
      });
      if (err?.response?.status === 401) logout();
  };

  const getAllOrders = () => fetchOrderDetails(orderId);
  const { data: orderDetails, refetch } = useQuery(
    ["orders", orderId],
    getAllOrders
  );

  const {
    data: defaultList,
    isLoading,
    isErrorD,
    error,
    isFetching,
  } = useGetDefaults(onSuccess, "shootType");

  const transformation = (data) => {
    return data.map((item) => {
      return {
        ...item,
        value: item.key,
        label: item.name,
      };
    });
  };

  const { data: companiesList, isError } = useCompanies(
    onSuccess,
    transformation
  );

  if (isError || isErrorD) {
    logout();
  }

  useEffect(() => {
    if (orderDetails?.data) {
      let returnIds =
        (orderDetails?.data?.returnBoxInfo?.length > 0 &&
          orderDetails?.data?.returnBoxInfo?.map(
            (item) => item?.parentBoxId
          )) ||
        [];
      let detailArray = [];

      orderDetails?.data?.boxInfo.forEach((item) => {
        let isItemInReturn = returnIds.indexOf(item?._id) > -1;
        item["isItemInReturn"] = isItemInReturn;
        const returnFlag = item?.isReturnRequested;
        detailArray.push(item);
        if (isItemInReturn && returnFlag) {
          let returnItemIndex = orderDetails?.data?.returnBoxInfo?.findIndex(
            (itm) => itm?.parentBoxId === item?._id
          );
          detailArray.push(orderDetails?.data?.returnBoxInfo[returnItemIndex]);
        } else {
          detailArray.push({});
        }
        setBoxInfoCopy([...detailArray]);
      });
    }
  }, [orderDetails]);

  useEffect(() => {
    if (orderDetails?.data && companiesList) {
      let findCompany = companiesList.find(
        (el) => el.key == orderDetails?.data?.company
      );
      setCompanyAddress(findCompany?.adresses);
    }
  }, [orderDetails, companiesList]);

  useEffect(() => {
    if (courierFlag === false) {
      setIsReturningBox(false);
      setSelectedBoxForReturn(null);
      setIsReturnByFlx(false);
      setIsReturnBySelf(false);
      setIsParentBox(false);
      setBoxInfoFlag(false);
      refetch();
    }
  }, [courierFlag]);

  const onBookingSuccess = () => {
    api.success({
      message: "Great!",
      description: "Shipment created successfully",
      placement: "topRight",
    });
    setLoader(false);
    refetch();
  };

  const {
    mutate: createShipmentData,
    data: createShipDetails,
    isLoading: loadingCreateShipment,
  } = useCreateShipment(onSuccess, onError);
  const { mutate: bookOrderData } = useBookOrder(onBookingSuccess);
  const { data: studioList } = useListingStudios(onSuccess);
  // const { data: selectStudio } = useStudios(onSuccess, transformation);

  const {
    mutate: returnShipment,
    data: returnShipDetail,
    isLoading: isReturnLoading,
  } = useReturnShipment(onSuccess, onError);

  const onStudioChange = (id) => {
    setAssignedStudioId(id);
  };
  const createShipment = (id) => {
    setBoxId(id);
    setCourierFlag(true);
    let tempData = {
      orderId,
      boxId: id,
      assignedStudioId,
    };
    createShipmentData(tempData);
  };

  const assignStudioToSelfShippedBox = (boxId) => {
    if (!assignedStudioId)
      return api["warning"]({
        message: "Please select a Studio",
      });
    setLoader(true);
    setBoxId(boxId);
    const tempData = {
      orderId: orderId,
      boxId: boxId,
      assignedStudioId: assignedStudioId,
      selectedCourierId: null,
      easyshipId: null,
      pickupDate: null,
    };
    bookOrderData(tempData);
  };

  const recieveShipmentDetails = (data) => {};

  const chooseMessage = (data) => {
    setCourierDetails(data);
  };

  const closeBoxInfo = () => {
    setBoxInfoFlag(false);
    setIsParentBox(false);
    setIsReturnByFlx(false);
    setIsReturnBySelf(false);
  };

  const handleBoxCard = async (box) => {
    let newBox = {
      ...box,
      id: uuidv4(),
      boxType: orderDetails?.data?.logisticsType,
    };

    newBox["dst"] = newBox.src;
    delete newBox["src"];
    let finalData = {};

    finalData["boxId"] = selectedBoxForReturn?._id;
    finalData["orderId"] = orderDetails?.data?._id;

    if (isReturnBySelf) {
      finalData["boxInfo"] = { ...newBox };
    } else {
      finalData["toAddress"] = box?.src;
    }
    try {
      returnShipment(finalData);
      setAssignedStudioId(selectedBoxForReturn?.studioId);
      setIsReturningBox(true);
      setCourierFlag(true);
    } catch (err) {
      api.error({
        message: "Great!",
        description: err.response.data.message,
        placement: "topRight",
      });
    }

    // let result = await returnShipment(finalData);
    // setBoxInfoFlag(false);
    // setIsParentBox(false);
    // setIsReturnByFlx(false);
    // setIsReturnBySelf(false);
  };
  const handleClientBoxCard = async (obj) => {
    let finalData = {};
    finalData["boxId"] = selectedBoxForReturn?._id;
    finalData["orderId"] = orderDetails?.data?._id;
    let result = await returnShipment({ ...finalData, ...obj });

    setBoxInfoFlag(false);
    setIsParentBox(false);
    setIsReturnByFlx(false);
    setIsReturnBySelf(false);
  };

  // Local Components
  const studioSelectionActionButton = (logisticsType, boxInfo) => {
    if (boxInfo.isStudioAssigned) {
      return null;
    }
    return logisticsType === "flixstock" ? (
      <DefaultButton
        text="Select Courier"
        disabled={boxInfo.isStudioAssigned ? true : false}
        clickHandler={() => createShipment(boxInfo._id)}
        customClass="mr-2"
      />
    ) : (
      <DefaultButton
        text="Assign Studio"
        clickHandler={() => assignStudioToSelfShippedBox(boxInfo._id)}
        disabled={boxInfo.isStudioAssigned ? true : false}
        customClass="mr-2"
      />
    );
  };
  const SelectListForStudio = (boxInfo) => {
    if (boxInfo.isStudioAssigned) {
      return <span>{boxInfo.studioName}</span>;
    }
    return (
      <Select
        placeholder={
          boxInfo.studioName ? boxInfo.studioName : "Select a Studio"
        }
        onChange={onStudioChange}
        allowClear
        disabled={boxInfo.isStudioAssigned ? true : false}
        defaultValue={boxInfo.studioName}
      >
        {studioList?.map((el) => {
          return (
            <Option key={el._id} value={el._id}>
              {el.name}
            </Option>
          );
        })}
      </Select>
    );
  };
  const boxInfoCard = (boxInfo, orderDetails) => {
    return (
      <div>
        <BoxInfoCard
          data={boxInfo}
          insured={true}
          weight={boxInfo?.weight}
          dimensions={boxInfo?.dimensions}
          logistictype={orderDetails?.data?.logisticsType}
          parentBoxId={boxInfo?.parentBoxId}
        />
      </div>
    );
  };

  const getLabelGenerationState = (boxInfo) => {
    if (boxInfo?.shippingLabel?.label_state === Success) {
      return (
        <div className="download_label_generation_button">
          <Button
            type="default"
            target="__blank"
            href={boxInfo?.shippingLabel?.label_url}
            size="small"
            danger
          >
            Download Label
          </Button>
        </div>
      );
    }

    if (boxInfo?.shippingLabel?.label_state === Failed) {
      return (
        <div
          className="download_label_generation_button"
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <Tooltip title={boxInfo?.shippingLabel?.error_msg || ""}>
            <CloseSquareOutlined
              style={{
                color: "red",
              }}
            />
          </Tooltip>
        </div>
      );
    }

    if (boxInfo?.shippingLabel?.label_state === Pending) {
      return (
        <div className="download_label_generation_button">
          <Tooltip title={boxInfo?.shippingLabel?.label_state}>
            <Button type="default" size="small" loading>
              Loading
            </Button>
          </Tooltip>
        </div>
      );
    }

    return null;
  };

  const checkTitle = (boxInfo) => {
    if (boxInfo?.parentBoxId) {
      return "Outbound";
    }
    return "Inbound";
  };

  const handleReturnRequest = (boxInfo, logisticsType) => {
    if (logisticsType === "flixstock") {
      setIsReturnByFlx(true);
      setIsReturnBySelf(false);
    } else {
      setIsReturnBySelf(true);
      setIsReturnByFlx(false);
    }
    setIsParentBox(true);
    setBoxInfoFlag(true);
    setSelectedBoxForReturn(boxInfo);
  };

  return (
    <div className="booking_container">
      {contextHolder}
      {/* {BookingHeader(orderDetails)} */}
      {BookingHeader(orderDetails)}
      {loader ? (
        <Spin className="spin-center" />
      ) : (
        <div className="booking_sections">
          <div className="address_details">
            {boxInfoCopy?.map((boxInfo, index) => {
              if (Object.keys(boxInfo)?.length === 0) {
                return (
                  <Card
                    style={{
                      width: "48%",
                      border: "0",
                    }}
                    // className="box_card"
                  ></Card>
                );
              }
              return (
                <Card
                  style={{
                    width: "48%",
                  }}
                  className="box_card"
                >
                  <div className="box_card_outer_div">
                    <div className="box_card_inner_div"></div>
                    <h4> {checkTitle(boxInfo)}</h4>
                  </div>
                  <div className="box_card_main_div">
                    <div className="main_div_box_info_left">
                      {boxInfoCard(boxInfo, orderDetails)}
                    </div>

                    <div className="main_div_box_info_right">
                      {!boxInfo?.parentBoxId && (
                        <div className="select_studio">
                          <h4 className="font-size-m">
                            {boxInfo.isStudioAssigned
                              ? "Studio"
                              : "Select Studios"}
                          </h4>
                          <div className="d-flex drop_spacing">
                            {SelectListForStudio(boxInfo)}
                            {studioSelectionActionButton(
                              orderDetails?.data?.logisticsType,
                              boxInfo
                            )}
                          </div>
                        </div>
                      )}
                      {boxInfo?.shippingLabel && (
                        <div className="label_download_status">
                          <label className="font-size-m">
                            Label Generation
                          </label>
                          <div className="d-flex">
                            {getLabelGenerationState(boxInfo)}
                          </div>
                        </div>
                      )}
                      {!boxInfo?.parentBoxId &&
                        boxInfo?.isStudioAssigned &&
                        !boxInfo?.isReturnRequested && (
                          <div className="label_shipment">
                            <label className="font-size-m">
                              Return Shipment
                            </label>
                            <div className="d-flex return_shipment_button">
                              <Button
                                type="default"
                                size="small"
                                onClick={(e) =>
                                  handleReturnRequest(
                                    boxInfo,
                                    orderDetails?.data?.logisticsType
                                  )
                                }
                                danger
                              >
                                Initiate Shipment Outbound
                              </Button>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>
      )}
      {courierFlag && (
        <DynamicModal
          open={true}
          width={1000}
          component={
            <CourierList
              orderId={orderId}
              boxId={boxId || returnShipDetail?.data?.returnBoxId}
              assignedStudioId={assignedStudioId}
              data={
                createShipDetails?.data || returnShipDetail?.data?.shipmentObj
              }
              setCourierFlag={setCourierFlag}
              recieveShipmentDetai={recieveShipmentDetails}
              chooseMessage={chooseMessage}
              isLoading={loadingCreateShipment || isReturnLoading}
              isReturningBox={isReturningBox}
            />
          }
        />
      )}
      {boxInfoFlag && (
        <BoxInfoModal
          open={boxInfoFlag}
          close={closeBoxInfo}
          handleBoxCard={handleBoxCard}
          handleClientBoxCard={handleClientBoxCard}
          eshipboxes={defaultList?.eshipboxes}
          toSideBox={isParentBox}
          isReturnByFlx={isReturnByFlx}
          isReturnBySelf={isReturnBySelf}
        />
      )}
    </div>
  );
};

export default BookingDetails;
